import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ImageGalleryComponent } from "./image-gallery.component";
import { GalleriaModule } from "primeng/galleria";
import { ToolbarModule } from "primeng/toolbar";
import { ButtonModule } from "primeng/button";
import { ImageModule } from 'primeng/image';
import { TranslateModule } from "@ngx-translate/core";
import { SharedPipeModule } from "../shared/shared.module";

@NgModule({
    imports: [
        CommonModule,
        GalleriaModule,
        ToolbarModule,
        ButtonModule,
        TranslateModule,
        ImageModule,
        SharedPipeModule
    ],
    declarations: [
        ImageGalleryComponent,
    ],
    exports: [
        ImageGalleryComponent
    ]

})
export class ImageGalleryModule {}